"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZeppelinsRebalanced = void 0;
var Card_1 = require("../../Card");
var CardType_1 = require("../../CardType");
var Resources_1 = require("../../../Resources");
var CardName_1 = require("../../../CardName");
var CardRequirements_1 = require("../../CardRequirements");
var CardRenderer_1 = require("../../render/CardRenderer");
var Size_1 = require("../../render/Size");
var ZeppelinsRebalanced = (function (_super) {
    __extends(ZeppelinsRebalanced, _super);
    function ZeppelinsRebalanced() {
        return _super.call(this, {
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.ZEPPELINS_REBALANCED,
            cost: 11,
            requirements: CardRequirements_1.CardRequirements.builder(function (b) { return b.oxygen(5); }),
            metadata: {
                cardNumber: '129',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.production(function (pb) {
                        pb.megacredits(1).slash();
                        pb.city(Size_1.Size.SMALL).any.asterix();
                    });
                }),
                description: 'Requires 5% oxygen. Increase your M€ production 1 step for each City tile ON MARS.',
                victoryPoints: 1,
            },
        }) || this;
    }
    ZeppelinsRebalanced.prototype.play = function (player) {
        player.addProduction(Resources_1.Resources.MEGACREDITS, player.game.getCitiesInPlayOnMars(), { log: true });
        return undefined;
    };
    ZeppelinsRebalanced.prototype.getVictoryPoints = function () {
        return 1;
    };
    return ZeppelinsRebalanced;
}(Card_1.Card));
exports.ZeppelinsRebalanced = ZeppelinsRebalanced;
//# sourceMappingURL=ZeppelinsRebalanced.js.map